// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updatePartialDebitModalVisibility = visibility =>

    dispatch => {

        addRemoveModalClass(visibility);

        dispatch({
            type: actions.UPDATE_TCSM_PARTIAL_DEBIT_MODAL_VISIBILITY,
            visibility
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/partial-debit-modal.js